import React from 'react';
import InformingBlockTitle from '../../../components/InformingBlockTitle';
import styles from '../css/index.module.scss';

function InputsBlock({ title, children, width = 440, withTitleInfo = false }) {
  return (
    <div className={styles.inputBlock} style={{ width: `${width}px` }}>
      {withTitleInfo ? (
        <InformingBlockTitle
          title={title}
          titleClassName={styles.inputBlockTitle}
          className={styles.inputBlockTitleRow}
        />
      ) : (
        <p className={styles.inputBlockTitle}>{title}</p>
      )}
      {children}
    </div>
  );
}

export default InputsBlock;
